import React from 'react';
import { useAITTheme } from '@this/shared/ui/theme';

export const AdminContentIn = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ style, ...props }, ref) =>
    React.createElement('div', { ref, ...props, style: { width: '100%', padding: 20, ...style } })
);

export const Table = React.forwardRef<HTMLTableElement, React.TableHTMLAttributes<HTMLTableElement>>(
  ({ style, ...props }, ref) =>
    React.createElement('table', {
      ref,
      ...props,
      style
    })
);

export const DashboardTableTh = React.forwardRef<
  HTMLTableHeaderCellElement,
  React.ThHTMLAttributes<HTMLTableHeaderCellElement>
>(({ style, ...props }, ref) =>
  React.createElement('th', { ref, ...props, style: { padding: '4px 6px', minWidth: 70, ...style } })
);

export const DashboardTableTd = React.forwardRef<
  HTMLTableDataCellElement,
  React.TdHTMLAttributes<HTMLTableDataCellElement>
>(({ style, ...props }, ref) =>
  React.createElement('td', { ref, ...props, style: { padding: '4px 6px', minWidth: 70, ...style } })
);

export const Flex = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ style, ...props }, ref) => React.createElement('div', { ref, ...props, style: { display: 'flex', ...style } })
);

export const Red = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ style, ...props }, ref) => {
    const { theme } = useAITTheme();

    return React.createElement('div', { ref, ...props, style: { color: theme.redColor, ...style } });
  }
);
